exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".style-module_ApiKeyManager_3m1u8W-LNZdrXFAx3YQkgs {\n    float: right;\n    margin: 5px;\n}\n", "", {"version":3,"sources":["/root/app/src/pages/SwaggerUI/style.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;CACf","file":"style.module.css","sourcesContent":[".ApiKeyManager {\n    float: right;\n    margin: 5px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"ApiKeyManager": "style-module_ApiKeyManager_3m1u8W-LNZdrXFAx3YQkgs"
};